import { Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "../scenes/dashboard/index";
import OverView from "../scenes/../BScenes/OverView/index";
import CircularProgress from "@mui/material/CircularProgress";
import React, { Suspense, useEffect } from "react";
import { menu, mobileNotifcation } from "./MobileRoute.js";
import PageLoader from "../BScenes/General/Loading/PageLoading.tsx";
import {
  LazyDepositDocument,
  LazyOrderPaymentArchive,
  LazyOrderPaymentFinancial,
} from "./OrderPaymentRoute.js";
import {
  LazyFinancialTransaction,
  LazyFinancialTransactionCategory,
  LazyCalenderEvent,
  LazyListOfLoan,
  LazyMafsaInsuranceReport,
  LazyPettyCashList,
} from "./FinancialRoute.js";
import NotFound from "../Pages/NotFound/index.jsx";

const token = JSON.parse(localStorage.getItem("userInfo"));
const LazyPreOrder = React.lazy(() => import("../scenes/../BScenes/Modules/PreOrder/PreOrder.tsx"));
const LazyPathDefinition = React.lazy(() => import("../scenes/../BScenes/Modules/PathDefinition/PathDefinition.tsx"));
const LazyRegionDefinition = React.lazy(() => import("../scenes/../BScenes/Modules/RegionDefinition/RegionDefinition.tsx"));
const LazyCustomerMachine = React.lazy(() => import("../scenes/../BScenes/Modules/CustomerMachine/CustomerMachine.tsx"));
const LazyCustomerGroup = React.lazy(() => import("../scenes/../BScenes/Modules/CustomerGroup/CustomerGroup.tsx"));
const LazyCustomerSettlementType = React.lazy(() => import("../scenes/../BScenes/Modules/CustomerSettlementType/CustomerSettlementType.tsx"));
const LazycustomerMachineType = React.lazy(() => import("../scenes/../BScenes/Modules/CustomerMachineType/CustomerMachineType.tsx"));
const LazyCustomerProducts = React.lazy(() => import("../BScenes/Modules/CustomerProduct/CustomerProducts.tsx"));
const LazyCustomer = React.lazy(() => import("../BScenes/Modules/Customer/Customer.tsx"));




// customerMachineType





const LazyLetters = React.lazy(() => import("../scenes/Letters/index.js"));
const LazyTickets = React.lazy(() => import("../scenes/Ticket/Ticket"));








const LazyScheduler = React.lazy(() => import("../scenes/Scheduler/index.js"));


const lazyCustomerArchivedOrders = React.lazy(() =>
  import("../scenes/CustomerArchivedOrders/index.js")
);

const lazySentCartablePerson = React.lazy(() =>
  import("../scenes/PersonFroms/SentCartablePerson/SentCartablePerson.jsx")
);





const Orders = React.lazy(() =>
  import("../BScenes/Orders/index")
);







const LazyInfoMachine = React.lazy(() =>
  import("../scenes/ConsumableMaterial/InfoMachine/InfiMachine.js")
);








/*================================ OrganizationDefinitions ==============================*/
const LazyChart = React.lazy(() =>
  import("../scenes/Organization/Chart/Chart.js")
);
const LazyTeams = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Teams/Teams.js")
);
const LazyRoles = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Roles/Roles.js")
);
const LazyUnits = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Units/Units.js")
);
const LazyEmployeeRegistration = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/EmployeeRegistration/EmployeeRegistration.js"
  )
);
const LazyCreateUserAccount = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/CreateUserAccount/CreateUserAccount.js"
  )
);



const LazyCreateAccount = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/UserAccount/UserAccount")
);
const LazyPositionsDefinition = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/PositionsDefinition/PositionsDefinition.js"
  )
);
const LazyWorkingGroups = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/WorkingGroups/WorkingGroups.js")
);
const LazyContracts = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Contracts/Contracts.js")
);
const LazyEmployment = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/DefinitionEmployment/DefinitionEmployment.js"
  )
);
const LazyPostDefinition = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/PostDefinition/PostDefinition.js")
);
const LazyBankInfo = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/BankInfo/BankInfoCRD.js")
);
const LazyBankAccount = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/BankInfo/AccountBank/AccountBank"
  )
);
const LazyChequeBook = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/BankInfo/ChequeBook/ChequeBook.js")
);
const LazyInsuranceJob = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/InsuranceJob/InsuranceJob.js")
);
const LazyTypeInsurance = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/TypeInsurance/TypeInsurance.js")
);
const LazyFiscalYear = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/FiscalYear/FiscalYear.js")
);
const LazyChartType = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/DefinitionChartType/ChartType.js")
);
const LazyPostType = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/DefinitionPostType/DefinitionPostType.js"
  )
);


const LazyDesignerGroup = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/DesignerGroup/index.js")
);
const LazySystemInformation = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/SystemInformation/index.jsx")
);
const LazyDefinitionForm = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/DefinitionForm/DefinitionForm.jsx")
);
const LazyDefinitionEnumOption = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/DefinitionEnumOption/EnumOption.jsx"
  )
);
const LazyProformaInvoiceProduction = React.lazy(() =>
  import(
    "../scenes/../BScenes/PerformaInvoiceProduction/PerformaInvoiceProduction"
  )
);
const LazyMessages = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Messages/Messages.jsx")
);
const LazyAnnouncement = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/Announcement/Announcement.jsx")
);
const LazyAnnouncementLogin = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/AnnouncementLogin/AnnouncementLogin.jsx"
  )
);
const LazyAccesGroups = React.lazy(() =>
  import("../scenes/OrganizationDefinitions/AccessGroups/AccessGroups.jsx")
);
/*================================ warehouse ==============================*/




const LazyNotFoundPage = React.lazy(() =>
  import("../Pages/PageLackOfAccess.jsx")
);






/*================================ Person Cartable ==============================*/
const lazyCartablePersonRecive = React.lazy(() =>
  import("../scenes/PersonFroms/ReciveCartablePerson/ReciveCartablePerson.jsx")
);
const lazyCartablePersonArchive = React.lazy(() =>
  import("../scenes/PersonFroms/ArciveCartablePerson/ArciveCartablePerson.jsx")
);
const lazyCartablePersonReferred = React.lazy(() =>
  import("../scenes/PersonFroms/ReferredCartablePerson/Referred.jsx")
);
const lazyRollCall = React.lazy(() =>
  import("../scenes/PersonFroms/RollCall/RollCall.jsx")
);
const lazyFunctionDesignersReport = React.lazy(() =>
  import("../scenes/PersonFroms/FunctionDesignersReport/index.js")
);
const lazyConsignment = React.lazy(() =>
  import("../scenes/PersonFroms/Consignment/Consignment.jsx")
);
const lazyIncomingGuest = React.lazy(() =>
  import("../scenes/PersonFroms/IncomingGuest/IncomingGuest.jsx")
);
const LazySecurityReport = React.lazy(() =>
  import("../scenes/PersonFroms/SecurityReport/SecurityReport.jsx")
);
const LazyPhoneBook = React.lazy(() =>
  import("../scenes/PersonFroms/PhoneBook/PhoneBook.jsx")
);
const LazyAllPersonCartable = React.lazy(() =>
  import("../scenes/PersonFroms/AllPersonCartable/AllPersonCartable.jsx")
);

const LazyEscrowExit = React.lazy(() =>
  import("../scenes/PersonFroms/EscrowExitTotal/EscrowExit.jsx")
);
const LazyOrderDiffrents = React.lazy(() =>
  import("../scenes/../BScenes/OrderDiffrents/index")
);
const LazyFinancialScheduler = React.lazy(() =>
  import("../scenes/Financial/Scheduler/index")
);

const Loading = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "600px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </div>
  );
};

const LazyComponent = ({ component: Component, ...props }) => (
  <Suspense fallback={<PageLoader/>}>
    <Component {...props} />
  </Suspense>
);
/*================================ Define Routes ==============================*/
// LazyScheduler
const routes = [
  { path: "overview", element: <OverView /> },
  { path: "scheduler", element: <LazyComponent component={LazyScheduler} /> },
  { path: "orders", element: <LazyComponent component={Orders} /> },

  // { path: "designer", element: <LazyComponent component={LazyDesigner} /> },
  {
    path: "customers",
    element: <LazyComponent component={LazyCustomer} />,
  },
  {
    path: "preOrder",
    element: <LazyComponent component={LazyPreOrder} />,
  },
   {
    path: "routeDefinition",
    element: <LazyComponent component={LazyPathDefinition} />,
  },
   {
    path: "regionDefinition",
    element: <LazyComponent component={LazyRegionDefinition} />,
  },
   {
    path: "customerMachine",
    element: <LazyComponent component={LazyCustomerMachine} />,
  },
   {
    path: "customerGroup",
    element: <LazyComponent component={LazyCustomerGroup} />,
  },
  {
    path: "customerSettlementType",
    element: <LazyComponent component={LazyCustomerSettlementType} />,
  },
  {
    path: "customerMachineType",
    element: <LazyComponent component={LazycustomerMachineType} />,
  },
   {
    path: "customerProducts",
    element: <LazyComponent component={LazyCustomerProducts} />,
  },

  { path: "teams", element: <LazyComponent component={LazyTeams} /> },
  { path: "departmans", element: <LazyComponent component={LazyUnits} /> },
  { path: "roles", element: <LazyComponent component={LazyRoles} /> },
  { path: "chart", element: <LazyComponent component={LazyChart} /> },
  {
    path: "createUserAccount",
    element: <LazyComponent component={LazyCreateAccount} />,
  },
  {
    path: "employeeRegistration",
    element: <LazyComponent component={LazyEmployeeRegistration} />,
  },
  {
    path: "createEmployeesAccount",
    element: <LazyComponent component={LazyCreateUserAccount} />,
  },
  {
    path: "PositionsDefinition",
    element: <LazyComponent component={LazyPositionsDefinition} />,
  },
  {
    path: "PostDefinition",
    element: <LazyComponent component={LazyPostDefinition} />,
  },
  {
    path: "WorkingGroups",
    element: <LazyComponent component={LazyWorkingGroups} />,
  },
  { path: "Contracts", element: <LazyComponent component={LazyContracts} /> },
  {
    path: "definitionEmployment",
    element: <LazyComponent component={LazyEmployment} />,
  },
  { path: "chart", element: <LazyComponent component={LazyChart} /> },
  {
    path: "infoMachine",
    element: <LazyComponent component={LazyInfoMachine} />,
  },
  { path: "bankInfo", element: <LazyComponent component={LazyBankInfo} /> }
  ,
  {
    path: "bankAccount",
    element: <LazyComponent component={LazyBankAccount} />,
  },
  {
    path: "cheqeBook",
    element: <LazyComponent component={LazyChequeBook} />,
  },
  {
    path: "insuranceJob",
    element: <LazyComponent component={LazyInsuranceJob} />
  },
  {
    path: "TypeInsurance",
    element: <LazyComponent component={LazyTypeInsurance} />,
  },
  {
    path: "fiscalYear",
    element: <LazyComponent component={LazyFiscalYear} />,
  },
  {
    path: "chartType",
    element: <LazyComponent component={LazyChartType} />,
  },
  {
    path: "PostType",
    element: <LazyComponent component={LazyPostType} />,
  },
  {
    path: "GroupDesigner",
    element: <LazyComponent component={LazyDesignerGroup} />,
  },
  {
    path: "403",
    element: <LazyComponent component={LazyNotFoundPage} />,
  },
  {
    path: "systemInformation",
    element: <LazyComponent component={LazySystemInformation} />,
  },
  {
    path: "form",
    element: <LazyComponent component={LazyDefinitionForm} />,
  },
  {
    path: "formSend",
    element: <LazyComponent component={lazySentCartablePerson} />,
  },
  {
    path: "formRecive",
    element: <LazyComponent component={lazyCartablePersonRecive} />,
  },
  {
    path: "formArchive",
    element: <LazyComponent component={lazyCartablePersonArchive} />,
  },
  {
    path: "formReferred",
    element: <LazyComponent component={lazyCartablePersonReferred} />,
  },
  {
    path: "enumOption",
    element: <LazyComponent component={LazyDefinitionEnumOption} />,
  },
  {
    path: "rollcall",
    element: <LazyComponent component={lazyRollCall} />,
  },
  {
    path: "consignment",
    element: <LazyComponent component={lazyConsignment} />,
  },
  {
    path: "incomingGuest",
    element: <LazyComponent component={lazyIncomingGuest} />,
  },
  {
    path: "securityReport",
    element: <LazyComponent component={LazySecurityReport} />,
  },
  {
    path: "phoneBook",
    element: <LazyComponent component={LazyPhoneBook} />,
  },
  {
    path: "proformaInvoiceProduction",
    element: <LazyComponent component={LazyProformaInvoiceProduction} />,
  },
  {
    path: "getAllPersonCartable",
    element: <LazyComponent component={LazyAllPersonCartable} />,
  },
  {
    path: "messages",
    element: <LazyComponent component={LazyMessages} />,
  },
  {
    path: "announcement",
    element: <LazyComponent component={LazyAnnouncement} />,
  },
  {
    path: "announcementLogin",
    element: <LazyComponent component={LazyAnnouncementLogin} />,
  },
  {
    path: "letters",
    element: <LazyComponent component={LazyLetters} />,
  },
  {
    path: "menu",
    element: <LazyComponent component={menu} />,
  },
  {
    path: "mobileNotifcation",
    element: <LazyComponent component={mobileNotifcation} />,
  },
  /*======= Order payment =======*/
  {
    path: "depositDocument",
    element: <LazyComponent component={LazyDepositDocument} />,
  },
  {
    path: "orderPaymentFinancial",
    element: <LazyComponent component={LazyOrderPaymentFinancial} />,
  },
  {
    path: "orderPaymentArchive",
    element: <LazyComponent component={LazyOrderPaymentArchive} />,
  },
  {
    path: "escrowExit",
    element: <LazyComponent component={LazyEscrowExit} />,
  },
  /*================== Financial =================*/
  {
    path: "financial/FinancialTransaction",
    element: <LazyComponent component={LazyFinancialTransaction} />,
  },
  {
    path: "CustomerArchivedOrders",
    element: <LazyComponent component={lazyCustomerArchivedOrders} />,
  },
  {
    path: "financial/MafsaInsuranceReport",
    element: <LazyComponent component={LazyMafsaInsuranceReport} />,
  },
  {
    path: "accessGroups",
    element: <LazyComponent component={LazyAccesGroups} />,
  },
  {
    path: "financialTransactionCategory",
    element: <LazyComponent component={LazyFinancialTransactionCategory} />,
  },
  {
    path: "calenderEvent",
    element: <LazyComponent component={LazyCalenderEvent} />,
  },
  {
    path: "listOfLoan",
    element: <LazyComponent component={LazyListOfLoan} />,
  },
  {
    path: "pettyCashList",
    element: <LazyComponent component={LazyPettyCashList} />,
  },
  {
    path: "orderDiffrents",
    element: <LazyComponent component={LazyOrderDiffrents} />,
  },
  {
    path: "functionDesignersReport",
    element: <LazyComponent component={lazyFunctionDesignersReport} />,
  },
  {
    path: "financial/scheduler",
    element: <LazyComponent component={LazyFinancialScheduler} />,
  },
    {
    path: "ticket",
    element: <LazyComponent component={LazyTickets} />,
  },
 



];

const DashRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />}>
          {routes.map(({ path, element }, index) => (
            <Route key={index} path={path} element={element} />
          ))}
        </Route>
        {token !== null && <Route path="*" element={<NotFound />} />}{" "}
      </Routes>
    </>
  );
};

export default DashRoutes;

